<template>
  <div id="userManage">
    <headerTop title="用户管理" :getleft="showArrow" :showUser="showUser" />
    <el-row class="mt20">
      <el-col :span="4"><navLeft :activeIndex="0" /></el-col>
      <el-col :span="20" class="system">
        <el-card>
          <div slot="header" class="clearfix">
            <span style="font-size: 16px; font-weight: 600">全部用户</span>
            <el-button
              style="
                float: right;
                padding: 3px 0;
                font-size: 14px;
                font-weight: 600;
              "
              type="text"
              icon="el-icon-plus"
              @click="addUserBtn"
              >新增用户</el-button
            >
          </div>
          <div>
            <el-row>
              <el-form>
                <el-col :span="5">
                  <el-form-item label="姓名：" class="input-width">
                    <el-input
                      v-model="filter.name"
                      prefix-icon="el-icon-search"
                      placeholder="搜索"
                    >
                      <!-- clearable
                      @clear="clearName" -->
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="用户状态：">
                    <el-select
                      v-model="filter.status"
                      clearable
                      @clear="clearStatus"
                      placeholder="请选择"
                    >
                      <el-option label="正常" value="0"> </el-option>
                      <el-option label="删除" value="1"> </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="9">
                  <el-form-item label="创建时间：">
                    <el-date-picker
                      v-model="filter.date"
                      type="daterange"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="changeDate"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="4" class="flex-end">
                  <el-button type="primary" @click="searchEvent"
                    >查询</el-button
                  >
                  <el-button @click="clearAll">清空</el-button>
                </el-col>
              </el-form>
            </el-row>
            <!-- max-height="550" -->
            <el-table :data="tableData" stripe border style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                width="60"
                fixed="left"
              >
              </el-table-column>
              <el-table-column prop="nickName" label="姓名" fixed="left">
              </el-table-column>
              <el-table-column prop="account" label="用户名"> </el-table-column>
              <el-table-column label="所属部门" width="280">
                <template slot-scope="scope">
                  <p
                    class="orgName-style"
                    v-for="(item, index) in scope.row.organizations"
                    :key="'org_' + index"
                  >
                    {{ item }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column prop="sexName" label="性别"> </el-table-column>
              <el-table-column label="用户状态">
                <template slot-scope="scope">
                  <span v-show="scope.row.status == 0">正常</span>
                  <span v-show="scope.row.status == 1">删除</span>
                </template>
              </el-table-column>
              <el-table-column prop="mainName" label="是否主账号">
              </el-table-column>
              <el-table-column prop="creUserName" label="创建人">
              </el-table-column>
              <el-table-column prop="creTime" label="创建时间" width="180">
              </el-table-column>
              <el-table-column label="操作" width="130" fixed="right">
                <template slot-scope="scope">
                  <el-button
                    :disabled="scope.row.status == 1"
                    type="text"
                    @click="showDetails(scope.row)"
                    >详情</el-button
                  >
                  <el-button
                    type="text"
                    style="color: #f56c6c"
                    @click="delUser(scope.row)"
                    v-if="scope.row.status == 0"
                    >删除</el-button
                  >
                  <el-button
                    v-else
                    type="text"
                    style="color: #c0c4cc; cursor: not-allowed"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="mt20 pagination-style">
              <el-pagination
                v-show="total > 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 15, 20, 25, 30]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              >
              </el-pagination>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div v-if="dialogVisible1">
      <el-dialog
        title="新增用户"
        :visible.sync="dialogVisible1"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        width="35%"
        class="dialog-class"
      >
        <el-card class="userManage-card">
          <div class="userManage-page-cont">
            <div class="userManage-page-title">
              <span>基本信息</span>
            </div>
            <el-form
              ref="formRef"
              :rules="rules"
              :model="formData"
              class="userManage-addUser-form"
            >
              <el-form-item
                label="姓名"
                class="require-item mb30"
                label-width="110px"
                prop="name"
              >
                <el-input
                  v-model="formData.name"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="用户名"
                class="require-item mb30"
                label-width="110px"
                prop="userName"
              >
                <el-input
                  autocomplete="off"
                  clearable
                  v-model="formData.userName"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="密码"
                class="require-item mb30"
                label-width="110px"
                prop="password"
              >
                <el-input
                  autocomplete="new-password"
                  clearable
                  placeholder="请输入"
                  v-model="formData.password"
                  show-password
                ></el-input>
                <div v-show="showPassTip" class="pass-tip">
                  密码组合为数字+字母+特殊字符，长度大于等于8位且小于等于12位
                </div>
              </el-form-item>
              <el-form-item
                label="组织机构"
                class="org-label"
                style="margin-left: 13px"
                label-width="97px"
              >
                <span class="el-icon-edit-outline userMange-edit-icon"></span>
                <el-popover placement="bottom" class="h384" trigger="click">
                  <el-tree
                    ref="tree1"
                    :data="orgList"
                    show-checkbox
                    node-key="organizeId"
                    :check-strictly="true"
                    :props="prop1"
                    @check="checkOrg"
                  >
                  </el-tree>
                  <el-input
                    slot="reference"
                    type="text"
                    readonly
                    v-model="formData.orgNameList"
                  >
                  </el-input>
                </el-popover>
              </el-form-item>
              <el-form-item
                label="手机号"
                class="require-item mb30"
                label-width="110px"
                prop="tel"
              >
                <el-input
                  v-model="formData.tel"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="性别" class="require-item" label-width="110px">
                <el-select v-model="formData.sex">
                  <el-option
                    v-for="item in sexList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="微信号"
                style="margin-left: 13px"
                label-width="97px"
                class="mb30"
                prop="wx"
              >
                <el-input
                  v-model="formData.wx"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="邮箱"
                style="margin-left: 13px"
                label-width="97px"
                class="mb30"
                prop="email"
              >
                <el-input
                  v-model="formData.email"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="是否主账号"
                class="require-item"
                label-width="110px"
              >
                <el-radio-group
                  v-model="formData.account"
                  @change="changeAccount"
                >
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <div class="userManage-page-title" style="margin-top: 50px">
              <span>菜单权限</span>
            </div>
            <div class="userManage-menu-cont" v-show="formData.account == 1">
              <el-tree
                ref="menu1"
                style="margin: 20px 10px 0 10%"
                :data="menuData"
                show-checkbox
                node-key="menuId"
                :check-strictly="true"
                :props="prop2"
                @check="checkMenu"
              >
              </el-tree>
            </div>
            <div class="userManage-menu-cont" v-show="formData.account == 2">
              <el-tree
                ref="menu2"
                style="margin: 20px 10px 0 10%"
                :data="sonMenuData"
                show-checkbox
                node-key="menuId"
                :check-strictly="true"
                :props="prop2"
                @check="checkMenu"
              >
              </el-tree>
            </div>
          </div>
        </el-card>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelAddUser">取 消</el-button>
          <el-button type="primary" @click="submitAddUser('formRef')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import headerTop from "../../components/headTop.vue";
import navLeft from "../../components/navLeft.vue";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      var passReg =
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*_.,。，/|#?&])[A-Za-z\d$@$!%*_.,。，/|#?&]{8,12}$/g;
      // if (value === "") {
      //   callback(new Error("请输入密码"));
      // } else
      if (!passReg.test(value)) {
        this.showPassTip = false;
        callback(
          new Error(
            "密码组合为数字+字母+特殊字符，长度大于等于8位且小于等于12位"
          )
        );
      } else {
        this.showPassTip = true;
        callback();
      }
    };
    var validateTel = (rule, value, callback) => {
      var telReg = /^1[3456789]\d{9}$/g;
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!telReg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    var validateWx = (rule, value, callback) => {
      var wxReg = /^[a-zA-Z][a-zA-Z\d_-]{5,19}$/g;
      if (value != "" && !wxReg.test(value)) {
        callback(new Error("请输入正确的微信号"));
      } else {
        callback();
      }
    };
    var validateEmail = (rule, value, callback) => {
      var wxReg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/g;
      if (value != "" && !wxReg.test(value)) {
        callback(new Error("请输入正确的邮箱号"));
      } else {
        callback();
      }
    };
    return {
      showArrow: true,
      showUser: true,
      filter: {
        status: "",
        date: [],
        name: "",
      },
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      dialogVisible1: false,
      formData: {
        name: "",
        userName: "",
        password: "",
        orgLinkCodeList: [],
        orgNameList: "",
        tel: "",
        sex: 1,
        wx: "",
        email: "",
        account: 1,
        menuSelected: [],
        menuSelectedList: [],
      },
      sexList: [
        {
          value: 1,
          label: "男",
        },
        {
          value: 2,
          label: "女",
        },
      ],
      menuData: [],
      prop1: {
        children: "childs",
        label: "name",
      },
      prop2: {
        children: "childs",
        label: "menuName",
        disabled: "disabled",
      },
      orgList: [],
      availableList: [],
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        tel: [{ validator: validateTel, trigger: "blur" }],
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ validator: validatePass, trigger: "blur" }],
        wx: [{ validator: validateWx, trigger: "blur" }],
        email: [{ validator: validateEmail, trigger: "blur" }],
      },
      menuData2: [],
      sonMenuData: [],
      showPassTip: true,
    };
  },
  components: {
    headerTop,
    navLeft,
  },
  mounted() {
    let self = this;
    self.getDataList();
    this.getOrgList();
    this.getHasMenus();
  },
  methods: {
    getDataList() {
      let self = this;
      let startTime = "",
        endTime = "";
      if (self.filter.date) {
        startTime = self.filter.date[0];
        endTime = self.filter.date[1];
      }
      let params = {
        pageNum: self.currentPage,
        pageSize: self.pageSize,
        data: {
          name: self.filter.name,
          phoneNumber: "",
          status: self.filter.status,
          startDate: startTime || "",
          endDate: endTime || "",
        },
      };
      self.$http.post(
        self.api.pageList,
        params,
        {},
        (res) => {
          if (res.code == 200) {
            if (res.body != "null") {
              res.body.forEach((item) => {
                item.sexName =
                  item.sex == 0 ? "未知" : item.sex == 1 ? "男" : "女";
                item.mainName = item.mainFlag == true ? "是" : "否";
              });
            }
            self.tableData = res.body;
            self.total = res.count;
          }
        },
        (error) => {}
      );
    },

    searchEvent() {
      this.currentPage = 1;
      this.getDataList();
    },

    clearAll() {
      this.filter = {
        name: "",
        status: "",
        date: [],
      };
      this.getDataList();
    },

    clearName() {
      this.filter.name = "";
      this.getDataList();
    },

    clearStatus() {
      this.filter.status = "";
      this.getDataList();
    },

    changeDate() {
      if (this.filter.date == []) {
        this.getDataList();
      }
    },

    addUserBtn() {
      this.dialogVisible1 = true;
    },
    showDetails(info) {
      window.localStorage.setItem("userId", info.userId);
      this.$router.push(
        "/authFront/userDetails/" + info.userId + "/" + info.nickName
      );
    },

    delUser(info) {
      let self = this;
      self
        .$confirm("此操作将永久删除该条信息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let params = new FormData();
          params.append("userId", info.userId);
          params.append("phone", "");
          self.$http.post(
            self.api.deleUser,
            params,
            {},
            (res) => {
              if (res.code == 200) {
                self.$message({
                  message: "删除成功",
                  type: "success",
                });
              }
              self.getDataList();
            },
            (error) => {}
          );
        })
        .catch(() => {});
    },

    getOrgList() {
      let self = this;
      let params = new FormData();
      self.$http.post(
        self.api.allOrganizationJSON,
        params,
        {},
        (res) => {
          if (res.code == 200) {
            if (res.body != "null") {
              self.orgList = res.body;
            }
          }
        },
        (error) => {}
      );
    },

    getHasMenus() {
      let self = this;
      let params = new FormData();
      self.$http.post(
        self.api.selfHasMenus,
        params,
        {},
        (res) => {
          if (res.code == 200) {
            if (res.body != "null") {
              self.availableList = res.body;
              self.getMenuList();
              self.getSonMenuList();
            }
          }
        },
        (error) => {}
      );
    },

    getMenuList() {
      let self = this;
      let params = new FormData();
      self.$http.post(
        self.api.allMenu,
        params,
        {},
        (res) => {
          if (res.code == 200) {
            if (res.body != "null") {
              let list = self.availableList;
              if (list && res.body) {
                tree(res.body);
                function tree(value) {
                  value.forEach((item) => {
                    let flag1 = true;
                    list.forEach((itemson) => {
                      if (item.menuId == itemson.menuId) {
                        flag1 = false;
                      }
                    });
                    if (flag1) {
                      item.disabled = "disabled";
                    }
                    if (item.childs && item.childs.length > 0) {
                      tree(item.childs);
                    }
                  });
                }
              }
              self.menuData = res.body;
            }
          }
        },
        (error) => {}
      );
    },

    getSonMenuList() {
      let self = this;
      let params = new FormData();
      self.$http.post(
        self.api.allMenu,
        params,
        {},
        (res) => {
          if (res.code == 200) {
            if (res.body != "null") {
              let list = self.availableList;
              if (list && res.body) {
                tree(res.body);
                function tree(value) {
                  value.forEach((item) => {
                    let flag2 = true;
                    list.forEach((itemson) => {
                      if (
                        item.menuId == itemson.menuId &&
                        itemson.position == 0
                      ) {
                        flag2 = false;
                      }
                    });
                    if (flag2) {
                      item.disabled = "disabled";
                    }
                    if (item.childs && item.childs.length > 0) {
                      tree(item.childs);
                    }
                  });
                }
              }
              self.sonMenuData = res.body;
            }
          }
        },
        (error) => {}
      );
    },

    changeAccount(value) {
      this.formData.menuSelected = [];
      this.formData.menuSelectedList = [];
      this.$refs.menu1.setCheckedKeys([], false, false);
      this.$refs.menu2.setCheckedKeys([], false, false);
    },

    checkMenu(data, node) {
      this.formData.menuSelected = node.checkedKeys;
      this.formData.menuSelectedList = node.checkedNodes;
    },

    checkOrg(data, node) {
      let result = "";
      if (node.checkedNodes) {
        node.checkedNodes.forEach((item) => {
          result += item.name + ",";
        });
      }
      this.formData.orgNameList = result;
      this.formData.orgLinkCodeList = node.checkedKeys;
      this.$forceUpdate();
    },

    cancelAddUser() {
      this.dialogVisible1 = false;
      this.formData = {
        name: "",
        userName: "",
        password: "",
        orgLinkCodeList: [],
        orgNameList: "",
        tel: "",
        sex: 1,
        wx: "",
        email: "",
        account: 1,
        menuSelected: [],
        menuSelectedList: [],
      };
      this.showPassTip = true;
      this.$refs.formRef.resetFields();
      this.$refs.tree1.setCheckedKeys([], false, false);
      this.$refs.menu1.setCheckedKeys([], false, false);
      this.$refs.menu2.setCheckedKeys([], false, false);
    },

    submitAddUser(formRef) {
      let self = this;
      self.$refs[formRef].validate((valid) => {
        if (valid) {
          if (self.formData.menuSelectedList) {
            self.formData.menuSelectedList.forEach((item) => {
              if (item.position == 2) {
                self.formData.menuSelected.push(127657991278);
                return;
              }
            });
            self.$refs.menu1.setCheckedKeys(
              self.formData.menuSelected,
              true,
              false
            );
          }
          let params = {
            nickName: self.formData.name, // 姓名
            account: self.formData.userName, // 用户名
            password: self.formData.password,
            email: self.formData.email,
            phoneNumber: self.formData.tel,
            sex: self.formData.sex,
            identityCard: "", // 身份证号
            photo: "", // 照片
            wechat: self.formData.wx,
            address: "", // 地址
            status: 0, // 用户状态
            mainFlag: Number(self.formData.account) == 1 ? true : false,
            organizeIds: self.formData.orgLinkCodeList,
            orgString: [],
            menuIds: self.formData.menuSelected,
          };
          self.$http.post(
            self.api.addUser,
            params,
            {},
            (res) => {
              if (res.code == 200) {
                self.cancelAddUser();
                self.$message.success("新增用户成功！");
                self.getDataList();
              } else {
                self.$message.warning(res.msg || "新增用户失败！");
              }
            },
            (error) => {}
          );
        } else {
          self.$message.warning("请检查输入正确后再提交");
        }
      });
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getDataList();
    },
  },
};
</script>

<style>
.require-item .el-form-item__label::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
.input-width .el-input {
  width: 60%;
}
.el-table thead {
  color: #666;
}
.el-table thead tr {
  background-color: #ededed !important;
}
.el-table thead tr th {
  border: 1px solid #e2e2e2;
}
.el-table th.el-table__cell {
  background-color: #ededed !important;
}
.el-table th.el-table__cell > .cell {
  text-align: center;
}
.el-table td.el-table__cell div {
  color: #000;
  text-align: center;
}
.el-icon-plus {
  font-size: 14px;
  font-weight: 600;
}
.mt20 {
  margin-top: 20px;
}
.mb30 {
  margin-bottom: 30px;
}
#userManage .system {
  padding: 0 20px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: fixed;
  left: 320px;
  bottom: 0;
  top: 84px;
  right: 0;
  overflow-y: scroll;
}
.pagination-style {
  width: 100%;
  height: 50px;
  position: relative;
}
.pagination-style .el-pagination {
  position: absolute;
  bottom: 0;
  left: 28%;
  text-align: center;
}
.el-table__empty-text {
  line-height: 100px;
  text-align: center;
  color: #1890ff;
  font-size: 16px;
}
.orgName-style {
  margin-bottom: 8px;
}
.orgName-style:last-child {
  margin-bottom: 0;
}
.flex-end {
  display: flex;
  justify-content: flex-end;
}
#userManage .dialog-class .el-dialog__header {
  padding: 15px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
#userManage .dialog-class .el-dialog__body {
  padding: 0;
}
#userManage .dialog-class .el-dialog__header .el-dialog__title {
  font-weight: 600;
}
#userManage .dialog-class .el-dialog__footer {
  padding: 15px 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}
.userManage-card {
  box-shadow: none;
}
.el-card.is-always-shadow {
  box-shadow: none;
  border-radius: 0;
}
.userManage-page-cont {
  width: 100%;
  margin: 0 auto;
}
.userManage-page-title {
  height: 44px;
  line-height: 44px;
  padding-left: 20px;
}
.userManage-page-title span {
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.userManage-page-title span::before {
  content: "";
  display: inline-block;
  width: 6px;
  height: 20px;
  background: #2878fc;
  border-radius: 3px;
  margin-right: 12px;
}
.userManage-addUser-form {
  width: 80%;
  padding-left: 26px;
  margin-top: 30px;
}
.userManage-addUser-form .el-form-item__label {
  text-align: left;
}
.userManage-addUser-form .el-form-item__label {
  font-size: 16px;
  font-weight: 600;
  color: #666666;
}
.userManage-addUser-form .pass-tip {
  color: #8e8e8e;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
}
#userManage .org-label {
  position: relative;
}
.userMange-edit-icon {
  position: absolute;
  left: -96px;
  top: 34px;
  font-size: 16px;
  font-weight: 600;
}
.userManage-menu-cont {
  width: 500px;
  height: 474px;
  overflow-y: auto;
  border-radius: 2px;
  border: 1px solid #e3e5e8;
  margin-left: 20px;
  margin-top: 15px;
}
.h384 {
  height: 384px;
  overflow-y: auto;
}
.el-popover {
  min-width: 238px;
}
.el-tree-node__label {
  font-size: 16px;
  font-weight: 600;
}
.el-tree__empty-text {
  line-height: 100px;
  text-align: center;
  color: #1890ff;
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/view/userManage/list.vue